import React from "react";
import { useLocation } from "react-router-dom";

const UpcomingDetails = ({ deatils }) => {
  const { state } = useLocation();

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Challenge Details</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Title of Challenge </label>
              <p>lorem Ipsum</p>
            </div>
            <div className="form-group">
              <label>Category</label>
              <p>Category 1</p>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Start Date </label>
                  <p>20/04/2023</p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Deadline Date </label>
                  <p>20/04/2023</p>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>No. of Prizes </label>
              <p>24</p>
            </div>
            <div className="form-group">
              <label>Prize Details </label>
              <ul>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
              </ul>
            </div>
            <div className="form-group">
              <label>Participation Rules </label>
              <ul>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
              </ul>
            </div>
            <div className="form-group">
              <label> Submission Guidelines </label>
              <ul>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
              </ul>
            </div>
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Video</h4>
          </div>
          <div className="TableList mt-4">
            <table className="table-hover">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Language</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>001</td>
                  <td>English</td>
                  <td>Video</td>
                  <td>
                    <div className="Actions">
                      <a
                        className="Eyes"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#DetailsVideo"
                      >
                        <i className="fa-regular fa-eye" />
                      </a>
                      <a
                        className="Edit"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#EditVideo"
                      >
                        <i className="fa-regular fa-pen-to-square" />
                      </a>
                      <a
                        className="Delete"
                        href="javascript:void(0);"
                        data-toggle="modal"
                        data-target="#ChallengeDelete"
                      >
                        <i className="fa-regular fa-trash-can" />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpcomingDetails;
